import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';

// ghh
import { FormControl } from '@angular/forms'
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MarsCategory, JsonFormData, MarsClassCategory, MarsClassification, MarsClassificationType, MarsMalfunctionType, SectionInfo, MarsIncidentRequestModel } from './gridclasses';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {
  ClientSideRowModelModule,
  ColDef,
  ColGroupDef,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ModuleRegistry,
} from "ag-grid-community";


@Component({
  selector: 'app-mars3grid',
  templateUrl: './mars3grid.component.html',
  styleUrls: ['./mars3grid.component.scss']
})
export class Mars3gridComponent implements OnInit {
  columns: Array<any> = [];
  displayedColumns = this.columns.map(c => c.columnDef);
  gridApi: GridApi;
  
  @Input() jsonFormData: JsonFormData;

  gridForm: FormGroup = this.frmBuilder.group({});

  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  filterValue = '';

  public formData: JsonFormData;
  public classificationCategoryData: Array<MarsClassCategory> = [];
  public classificationData: Array<MarsClassification> = [];
  public classificationTypeData: Array<MarsClassificationType> = [];
  public categoryData: Array<MarsCategory> = [];
  public malfunctionTypeComboData: Array<MarsMalfunctionType> = [];
  public malfunctionTypeSourceData: Array<MarsMalfunctionType> = [];

  // initial column list (no labels, since no checkboxes needed)
  public gridColumns: Array<any> = [
    {
      field: 'incidentId',      
      headerName: 'ID',
      width: 150,
    },
    {
      field: 'malfunctionDate',      
      headerName: 'Date',
      cellClass: "dateUS",
      valueFormatter: (params) => {
        if (params.value === '') { return ''; }
        const date = new Date(params.value);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
      },
      width: 150,
    },
    {
      field: 'homeBase1',      
      headerName: 'Base',
      width: 150,
    },
    {
      field: 'spikeBaseName',      
      headerName: 'Spike Base',
      width: 150,
    },
    {
      field: 'classificationName',
      headerName: 'Classification',
      width: 150,
    },
    {
      field: 'classificationTypeName',
      headerName: 'Type',
      width: 150,
    },
    {
      field: 'categoryName',
      headerName: 'Category',
      width: 150,
    },
    {
      field: 'malfunctionTypeName',
      headerName: 'Malfunction',
      width: 150,
    }
  ];

  private totalColumnWidth: number = 320;  // fixed colums width total

  // empty source
  gridSource: any = []

  // for optimum performance, use array where each index matches
  //  category id, if entry = 1, it's enabled, 0 = it's disabled
  //  this is preferrable to calling a function from the html 
  //  template, as with a possible high number of form scans, 
  //  function would be called every time!
  public categoryIds: Array<number> = [];

  filterForm = new FormGroup({
    classifications: new FormControl([]),
    classificationTypes: new FormControl([]),
    categories: new FormControl([]),
    malfunctionTypes: new FormControl([])
  });

  static MALFUNCTION_NAME = 'MALFUNCTION';

	columnMenu: any = {
		enabled: true,
		sort: true,
		columnsManager: true
	};

	sorting: any = {
		enabled: true,
		multiSorting: true
	};

  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    private http: HttpClient,
    private frmBuilder: FormBuilder
    ) 
  { 'ngInject' }

  ngOnInit(): void {
    // fetch the column info
    this.http
      .get('assets/columninfo.json')
      .subscribe((formData: JsonFormData) => {
        this.formData = formData;
        this.createForm();
      },
      error => {
        console.log("Error loading columninfo.json: " + error);
      });


    // fetch the classificaitons, types, categories, malfunctions
    let options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };

    axios
      .get(environment.API_URL + '/mars/classificationandcategorydata', options)
      .then((response) => {
        
        this.classificationCategoryData = response.data;

        axios
          .get(environment.API_URL + '/mars/malfunctiontypedata', options)
          .then((response) => {
            this.malfunctionTypeSourceData = response.data;
            this.malfunctionTypeComboData = this.malfunctionTypeSourceData.map( m => {
              return {
                malfunctionTypeId: m.malfunctionTypeId,
                malfunctionTypeName: m.malfunctionTypeName,
                selected: false
              }
            })
          })
          .catch(function (error) {
            console.log('Error fetching Malf. Data', error);            
          })
      
        this.getDropdownListsData();

      })
      .catch(function (error) {
        console.log('Error fetching Class. Data', error);
      })

      this.columns = [
        {
          columnDef: 'incidentId',
          header: 'ID',
          cell: (element: any) => `${element.incidentId}`,
        },
        {
          columnDef: 'malfunctionDate',
          header: 'Malfunction Date',
          cell: (element: any) => `${element.malfunctionDate}`,
        },
        {
          columnDef: 'homeBase1',
          header: 'Base',
          cell: (element: any) => `${element.homeBase1}`,
        },
        {
          columnDef: 'spikeBaseName',
          header: 'Spike Base',
          cell: (element: any) => `${element.spikeBaseName}`,
        },
        {
          columnDef: 'classificationName',
          header: 'Class',
          cell: (element: any) => `${element.classificationName}`,
        },
        {
          columnDef: 'classificationTypeName',
          header: 'Type',
          cell: (element: any) => `${element.classificationTypeName}`,
        },
        {
          columnDef: 'categoryName',
          header: 'Category',
          cell: (element: any) => `${element.categoryName}`,
        },
        {
          columnDef: 'malfunctionTypeName',
          header: 'Malfunction',
          cell: (element: any) => `${element.malfunctionTypeName}`,
        },
      ];
      this.displayedColumns = this.columns.map(c => c.columnDef);

  }

  createForm() {

    for (let section of this.formData.sections) {
      for (let subSection of section.subSections) {
        for (let column of subSection.columns) {
          this.gridForm.addControl(column.field, this.frmBuilder.control(''));
        }
      }
    }
  }

  getDropdownListsData() {
    for (var cls of this.classificationCategoryData) {
      // save the Category ID
      this.categoryIds.push(0);

      // classification
      if (!this.classificationData?.find( c => c.classificationId == cls.classificationId)) {
        let newCls: MarsClassification = {
          classificationId: cls.classificationId,
          classificationName: cls.classificationName,
          selected: false
        };

        this.classificationData.push(newCls);        
      }

      // classification type
      if (!this.classificationTypeData?.find( c => c.classificationTypeId == cls.classificationTypeId)) {
        let newClsType: MarsClassificationType = {
          classificationTypeId: cls.classificationTypeId,
          classificationTypeName: cls.classificationTypeName,
          selected: false
        };

        this.classificationTypeData.push(newClsType);        
      }
    }
  }

  classificationSelectionChanged(event) {
    // save statuses
    for (var cls of this.classificationData) {
      if (event.value.find( c => c == cls.classificationId)) {
        cls.selected = true;
      } else {
        cls.selected = false;
      }
    }

    this.setAvailableCategories();
  }

  classificationTypeSelectionChanged(event) {
    // save statuses
    for (var clsType of this.classificationTypeData) {
      if (event.value.find( c => c == clsType.classificationTypeId)) {
        clsType.selected = true;
      } else {
        clsType.selected = false;
      }
    }

    this.setAvailableCategories();
  }

  malfunctionTypeChanged(event) {
    for (var malfType of this.malfunctionTypeComboData) {
      if (event.value.find( mt => mt == malfType.malfunctionTypeId )) {
        malfType.selected = true;
      } else {
        malfType.selected = false;
      }
    }
  }

  categorySelectionChanged(event) {
    
    // save statuses
    for (var cat of this.categoryData) {
      if (event.value.find( c => c == cat.categoryId)) {
        cat.selected = true;
      } else {
        cat.selected = false;
      }
    }

    // if we have and checked 'Malfunction', populate the Malfunction Type combo
    this.malfunctionTypeComboData = [];
    for (let cat of this.categoryData) {
      if (cat.categoryName.toUpperCase() === Mars3gridComponent.MALFUNCTION_NAME && cat.selected) {
        for (var malf of this.malfunctionTypeSourceData) {
          if (!this.malfunctionTypeComboData?.find( m => m.malfunctionTypeId == malf.malfunctionTypeId)) {
            let newMalf: MarsMalfunctionType = {
              malfunctionTypeId: malf.malfunctionTypeId,
              malfunctionTypeName: malf.malfunctionTypeName,
              selected: false
            };

            this.malfunctionTypeComboData.push(newMalf);
          }
        }
      }
    }
  }

  setAvailableCategories() {

    // go thru all categories, for each,
    //  check to see if the required 
    //  class., class. type are set and 
    //  make visible if so

    this.categoryData = [];

    for (let clsCatData of this.classificationCategoryData) {

      let catIsEnabled = false;        
      // find the class. entry and see if it's set
      let clsDataEntry = this.classificationData.find(c => c.classificationId == clsCatData.classificationId);
      if (clsDataEntry) {
        if (clsDataEntry.selected) {
          let clsTypeDataEntry = this.classificationTypeData.find( ct => ct.classificationTypeId == clsCatData.classificationTypeId);
          if (clsTypeDataEntry) {
            if (clsTypeDataEntry.selected) {
              // add it to combo dropdown lis
              let newCat: MarsCategory = {
                categoryId: clsCatData.categoryId,
                categoryName: clsCatData.categoryName,
                selected: false
              };
      
              this.categoryData.push(newCat);
            }
          }
        }
      }
    }

    // sort the categories by name
    this.categoryData.sort((c1, c2) =>{
      let name1 = c1.categoryName.toLowerCase(),
          name2 = c2.categoryName.toLowerCase();

      if (name1 < name2) { return -1; }

      if (name2 > name1) { return 1; }

      return 0;
    });
  }

  onColumnCheckBoxChanged(event, column, selected) {
    if (event) {
      selected = event.checked
    } 
    
    if (selected) {
      // add column
      const newColumns = [
        ...this.gridColumns, 
        {
          field: column.field,
          columnDef: column.field,
          headerName: column.label,
          cellClass: column.type === 'date' ? "dateUS" : null,
          valueFormatter: (params) => {
            if (column.type !== 'date') { return params.value; }
            if (params.value === '') { return ''; }
            const date = new Date(params.value);
            return date.toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            });
          },



          // cell: (element: any) => 
          //   `${
          //     column.madb === true && column.type === "date" ? new Date(element.madbIncident[column.field]).toLocaleDateString() : column.madb === true ? element.madbIncident[column.field] :
          //     column.type === "boolean" ? element[column.field] === '' ? false : !!element[column.field] : 
          //     column.type === "date" ? element[column.field] === '' ? '' : new Date(element[column.field]).toLocaleDateString() : 
          //     element[column.field]
          //   }`,
        },
      ];
      this.columns = newColumns;
      this.displayedColumns = this.columns.map(c => c.columnDef);
      this.gridColumns = newColumns;

    } else {
      // remove column
      this.columns = this.columns.filter(c => c.columnDef !== column.field);
      this.gridColumns = this.gridColumns.filter(c => c.field !== column.field);
      this.displayedColumns = this.columns.map(c => c.columnDef);

    }
  }

  setResetCheckboxes(sectionHeading, event) {
    let selected: boolean = event.checked;
    for (let section of this.formData.sections) {
      for (let subSection of section.subSections) {
        if (subSection.header === sectionHeading) {
          for (let col of subSection.columns) {
            col.selected = selected;

            this.onColumnCheckBoxChanged(null, col, selected)
          }
        }
      }
    }
  }

  getData() {
    this.filterValue = '';
    this.gridSource = []
    this.loading = true;

    let options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };

    // gather the selected filter id's to pass 
    let incidentReq: MarsIncidentRequestModel = {
      ClassificationIds: new Array<number>,
      ClassificationTypeIds: new Array<number>,
      CategoryIds: new Array<number>,
      MalfunctionTypeIds: new Array<number>
    };


    for (let cls of this.classificationData) {
      if (cls.selected) {
        incidentReq.ClassificationIds.push(cls.classificationId);
      }
    }

    for (let clsType of this.classificationTypeData) {
      if (clsType.selected) {
        incidentReq.ClassificationTypeIds.push(clsType.classificationTypeId);
      }
    }

    for (let cat of this.categoryData) {
      if (cat.selected) {
        incidentReq.CategoryIds.push(cat.categoryId);
      }
    }

    for (let mt of this.malfunctionTypeComboData) {
      if (mt.selected) {
        incidentReq.MalfunctionTypeIds.push(mt.malfunctionTypeId);
      }
    }

    document.body.style.cursor = 'wait';
    axios.post(
      environment.API_URL + '/mars/incidentswithmadb/fetch', 
      incidentReq,
      options      
    )
    .then(response => {
      let returnData = response.data;
      console.log(returnData);
      // here we flatten the data, so that we can use it in the grid
      returnData?.forEach((item) => {
        if (item.madbIncident) {
          for (var key in item.madbIncident) {
            item.madbIncident[key] === '???' ? item.madbIncident[key] = '' : null;
            if (key === 'incidentDate') {
              item.madbIncidentDate = item.madbIncident[key]
            } else {
              item[key] = item.madbIncident[key];
            }
          }
        }
      });
      
      returnData?.forEach((item) => {
        // here we turn all null or undefined values into empty strings
        for (var key in item) {
          if (!item[key] || item[key] == null) {
            item[key] = '';
          }
        }
      });
      this.gridSource = returnData;
      this.gridForm.reset();
      this.loading = false;
    })
    .catch(function (error) {
      console.log('Error fetching Incident Data', error);
      this.loading = false;
      debugger;
    })
    .finally(function () {
      document.body.style.cursor = 'default'
    });
  }

  selectRow(row) {
    window.open('/#/mars/incident/' + row.incidentId, '_blank');
    
  }

  downloadAsCsv() {
    this.gridApi.exportDataAsCsv();
  }

  tableStringFilter(event: Event) {
    // if (!this.gridSource || this.gridSource.data.length === 0) { return null };
    // const filterValue = (event.target as HTMLInputElement).value;
    // let filteredGridSource = this.gridSource.data;
    // // here we remove any key value pair from any of the objects in the array that does not contain a key that is included in the columns array of objects as the column.columnDef
    // filteredGridSource = filteredGridSource.filter((item) => {
    //   for (var key in item) {
    //     if (!this.columns.find(c => c.columnDef == key)) {
    //       delete item[key]
    //     }
    //   }
    //   return item
    // })
    // this.gridSource = new MatTableDataSource<any>(filteredGridSource);
    // this.gridSource.filter = filterValue.trim().toLowerCase();
    // this.gridSource.sort = this.sort;
    this.gridApi.setGridOption(
      "quickFilterText",
      (document.getElementById("filter-text-box") as HTMLInputElement).value,
    );
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

  }

}
